import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'

import { Batch } from './Batch'
import { Container } from './Container'
import { Facility } from './Facility'
import { Place } from './Place'
import { Product } from './Product'
import { Sku } from './Sku'

export class Lost {
  @Expose({ name: 'xid' })
  guid?: string

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Batch)
  batch?: Batch

  @Type(() => Container)
  container?: Container

  @Expose({ name: 'original_place' })
  @Type(() => Place)
  originalPlace?: Place

  @Expose({ name: 'original_container' })
  @Type(() => Container)
  originalContainer?: Container

  @Expose({ name: 'date_received' })
  @Transform((value) => moment(value))
  dateReceived?: moment.Moment

  @Expose({ name: 'num_units' })
  numUnits?: string

  get objPath() {
    const objPath = []
    if (this.originalPlace) {
      objPath.push(...this.originalPlace.objPath)
    }
    if (this.originalContainer) {
      objPath.push(this.originalContainer)
    }
    return objPath
  }
}
